import { render, staticRenderFns } from "./searchDetail.vue?vue&type=template&id=3c35375c&scoped=true&"
import script from "./searchDetail.vue?vue&type=script&lang=js&"
export * from "./searchDetail.vue?vue&type=script&lang=js&"
import style0 from "./searchDetail.vue?vue&type=style&index=0&id=3c35375c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35375c",
  null
  
)

export default component.exports